import { render, staticRenderFns } from "./CoursePackDetails.vue?vue&type=template&id=5508fad1&scoped=true"
import script from "./CoursePackDetails.vue?vue&type=script&lang=js"
export * from "./CoursePackDetails.vue?vue&type=script&lang=js"
import style0 from "./CoursePackDetails.vue?vue&type=style&index=0&id=5508fad1&prod&scoped=true&lang=css"
import style1 from "./CoursePackDetails.vue?vue&type=style&index=1&id=5508fad1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5508fad1",
  null
  
)

export default component.exports